import Select from "react-select";
import { IS_REGISTERED } from "../../../constants/form";

export const InputName = ({customer, setCustomer, customerOptions, customerType}) => {
    return (<>
        {customerType === IS_REGISTERED ?
            <Select
                value={customer}
                onChange={(value) => {
                    setCustomer(value);
                }}
                options={customerOptions}
                isClearable
                placeholder="Nombre completo"
            /> : <input
                type="text"
                className="form-control"
                name="customerName"
                id="customerName"
                placeholder="Nombre completo"
                required
            />
        }
    </>)
} 